// Preset temi per personalizzazione UI utente.
// Ogni preset definisce le CSS variables del sidebar/brand.

export const THEME_PRESETS = [
  {
    id: "default",
    name: "Blu Classico",
    description: "Il tema standard EVOSOFT",
    emoji: "💼",
    sidebar_bg: "#020617",
    sidebar_text: "#cbd5e1",
    sidebar_hover_bg: "#1e293b",
    sidebar_active_bg: "#0052ff",
    sidebar_active_text: "#ffffff",
    brand_color: "#0052ff",
  },
  {
    id: "night_pro",
    name: "Notte Pro",
    description: "Grigio elegante, luce fioca",
    emoji: "🌙",
    sidebar_bg: "#111827",
    sidebar_text: "#d1d5db",
    sidebar_hover_bg: "#1f2937",
    sidebar_active_bg: "#6366f1",
    sidebar_active_text: "#ffffff",
    brand_color: "#6366f1",
  },
  {
    id: "ocean",
    name: "Oceano",
    description: "Blu marino profondo",
    emoji: "🌊",
    sidebar_bg: "#082f49",
    sidebar_text: "#bae6fd",
    sidebar_hover_bg: "#0c4a6e",
    sidebar_active_bg: "#0ea5e9",
    sidebar_active_text: "#ffffff",
    brand_color: "#0ea5e9",
  },
  {
    id: "forest",
    name: "Foresta",
    description: "Verde bosco rilassante",
    emoji: "🌲",
    sidebar_bg: "#052e16",
    sidebar_text: "#bbf7d0",
    sidebar_hover_bg: "#14532d",
    sidebar_active_bg: "#22c55e",
    sidebar_active_text: "#052e16",
    brand_color: "#16a34a",
  },
  {
    id: "sunset",
    name: "Tramonto",
    description: "Rosa/arancio caldo",
    emoji: "🌅",
    sidebar_bg: "#450a0a",
    sidebar_text: "#fecaca",
    sidebar_hover_bg: "#7f1d1d",
    sidebar_active_bg: "#f97316",
    sidebar_active_text: "#ffffff",
    brand_color: "#f97316",
  },
  {
    id: "wine",
    name: "Vino",
    description: "Bordeaux raffinato",
    emoji: "🍷",
    sidebar_bg: "#3f0d13",
    sidebar_text: "#f5d0d5",
    sidebar_hover_bg: "#6b1d24",
    sidebar_active_bg: "#dc2626",
    sidebar_active_text: "#ffffff",
    brand_color: "#dc2626",
  },
];

export const DEFAULT_THEME = THEME_PRESETS[0];

// Applica un tema alle CSS variables del document root.
export function applyTheme(theme) {
  const t = { ...DEFAULT_THEME, ...(theme || {}) };
  const root = document.documentElement;
  root.style.setProperty("--sidebar-bg", t.sidebar_bg);
  root.style.setProperty("--sidebar-text", t.sidebar_text);
  root.style.setProperty("--sidebar-hover-bg", t.sidebar_hover_bg);
  root.style.setProperty("--sidebar-hover-text", "#ffffff");
  root.style.setProperty("--sidebar-active-bg", t.sidebar_active_bg);
  root.style.setProperty("--sidebar-active-text", t.sidebar_active_text);
  root.style.setProperty("--sidebar-divider", t.sidebar_hover_bg);
  root.style.setProperty("--brand-color", t.brand_color);
}

export function getPresetById(id) {
  return THEME_PRESETS.find((p) => p.id === id) || DEFAULT_THEME;
}
